<template>
	<div>
		<b-row>
			<b-col cols="3">
				<b-form-group
					breakpoint="lg"
					label-size="sm"
					label-for="refName"
					class="required"
				>
					<b-form-input :required="true"
								  size="sm"
								  id="regNumber"
								  class="ml-1"
								  v-model="filter.regNumber"
								  :placeholder="$t('incomeFilter.regNo')"/>
				</b-form-group>
			</b-col>
			<b-col cols="3">
				<b-form-group
					breakpoint="lg"
					label-size="sm"
					label-for="fromDate"
					class="required"
					size="sm"
				>
					<date-picker v-model="filter.regDate.value" lang="ru" placeholder="oт" valueType="format"
								 format="DD-MM-YYYY"></date-picker>
					<!--<b-input-group size="sm">-->
					<!--<date-picker-->
					<!--mask="11-11-1111"-->
					<!--v-model="filter.regDate.value"-->
					<!--class="ml-1 form-control form-control-sm"-->
					<!--:placeholder=" $t('incomeFilter.from')" />-->
					<!--<b-input-group-addon>-->
					<!--<b-button size="sm" disabled>-->
					<!--<i class="fa fa-calendar"></i>-->
					<!--</b-button>-->
					<!--</b-input-group-addon>-->
					<!--</b-input-group>-->
				</b-form-group>
			</b-col>
			<b-col cols="3">
				<b-form-group
					breakpoint="lg"
					label-size="sm"
					label-for="fromDate"
					class="required"
					size="sm"
				>
					<!--<b-input-group size="sm">-->
					<!--<masked-input-->
					<!--v-model="filter.regDate.value2"-->
					<!--mask="11-11-1111"-->
					<!--class="ml-1 form-control form-control-sm"-->
					<!--:placeholder=" $t('incomeFilter.to')"/>-->
					<!--<b-input-group-addon>-->
					<!--<b-button size="sm" disabled>-->
					<!--<i class="fa fa-calendar"></i>-->
					<!--</b-button>-->
					<!--</b-input-group-addon>-->
					<!--</b-input-group>-->
					<date-picker v-model="filter.regDate.value2" lang="ru" :placeholder="$t('incomeFilter.to')"
								 valueType="format"
								 format="DD-MM-YYYY"></date-picker>
				</b-form-group>
			</b-col>
			<b-col v-if="isTransfer" cols="3">
				<b-form-group
					breakpoint="lg"
					label-size="sm"
					label-for="refName"
					class="required"
					size="sm"
				>
					<multiselect
						v-model="filter.department"
						:options="dropdowns.department"
						track-by="id"
						:show-labels="false"
						:allow-empty="true"
						label="name"
						:placeholder="$t('incomeFilter.depFrom')"
						class="multiselect-pricing"
					>
					</multiselect>
				</b-form-group>
			</b-col>
			<b-col v-if="isTransfer" cols="3">
				<b-form-group
					breakpoint="lg"
					label-size="sm"
					label-for="refName"
					class="required"
					size="sm"
				>
					<multiselect
						v-model="filter.toDepartment"
						:options="dropdowns.transferPermittedDepartments"
						track-by="id"
						:show-labels="false"
						:allow-empty="true"
						label="name"
						:placeholder="$t('incomeFilter.depTo')"
						class="multiselect-pricing"
					>
					</multiselect>
				</b-form-group>
			</b-col>
			<b-col cols="3" v-if="isChiqim">
				<b-form-group
					breakpoint="lg"
					label-size="sm"
					label-for="refName"
					class="required"
					size="sm"
				>
					<b-form-select
						size="sm"
						:options="dropdowns.department"
						:text-field="'name'"
						:value-field="'id'"
						v-model="filter.department"
					>
						<template slot="first">
							<option :value="null">-- {{ $t('incomeFilter.department') }} --</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col>
		<b-col>
				<b-button variant="dark" @click="filterItems" class="pull-right ml-2" size="sm"><i
					class="fa fa-search"></i> {{ $t('incomeFilter.search') }}
				</b-button>
				<b-button variant="danger" @click="clear" class="pull-right" size="sm"><i class="fa fa-close"></i> {{
					$t('incomeFilter.clear') }}
				</b-button>
				<div class="clearfix"></div>
			</b-col>
		</b-row>
		<b-row>
			<b-col cols="3" v-if="isKirim">
				<b-form-group
					breakpoint="lg"
					label-size="sm"
					label-for="refName"
					class="required"
					size="sm"
				>
					<b-form-select
						size="sm"
						:options="dropdowns.department"
						:text-field="'name'"
						:value-field="'id'"
						v-model="filter.department"
					>
						<template slot="first">
							<option :value="null">-- {{ $t('incomeFilter.department') }} --</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col>
			<b-col cols="3" v-if="isKirim">
				<b-form-group
					breakpoint="lg"
					label-size="sm"
					label-for="refName"
					class="required"
					size="sm"
				>
					<b-form-select
						v-model="filter.contragent"
						size="sm"
						:text-field="'fullName'"
						:value-field="'id'"
						:options="dropdowns.counterparties"
					>
						<template slot="first">
							<option :value="null">-- Поставщик --</option>
						</template>
					</b-form-select>

				</b-form-group>
			</b-col>
			
		</b-row>
		<hr>
	</div>
</template>

<script>


	import Filter from "../mixins/FilterItems";
	import MaskedInput from 'vue-masked-input'
	import Multiselect from 'vue-multiselect'

	export default {
		name: 'filterItems',
		mixins: [Filter],

		data() {
			return {}
		},
		methods: {},
		components: {
			MaskedInput,
			Multiselect
		}
	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

</style>
